<template>
  <div v-on:click="checkValue()" class="card">
    <div class="card-image">
      <img :src="pathImg" class="photo" />
    </div>
    <div class="text-card" v-bind:class="{ checked: checked }">
      <p>{{ card.message }}</p>
      <div class="checkbox">
        <Checkbox @change="checkValue()" :bind="checked" :background="'white'" />
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '../Input/Checkbox';
export default {
  props: ['card', 'step', 'index', 'type', 'stepImg'],
  name: 'Card',
  components: {
    Checkbox,
  },
  computed: {
    checked() {
      return this.type === 'correct'
        ? this.$store.getters.getMonoCheck(this.step) === this.index
        : this.$store.getters.getChecked({ step: this.step, index: this.index });
    },
    pathImg() {
      return require('../../../assets/image-marque/quizz-step-' +
        String(this.stepImg ? this.stepImg : this.step + 1) +
        '-' +
        String(this.index + 1) +
        '.jpg');
    },
  },
  methods: {
    checkValue() {
      return this.type === 'correct'
        ? this.$store.dispatch('setMonoCheck', { step: this.step, index: this.index })
        : this.$store.dispatch('setChecked', { step: this.step, index: this.index });
    },
  },
};
</script>

<style scoped>
.card-image {
  height: 28vh;
  overflow: hidden;
  width: 12vmax;
}
.text-card {
  height: 14vh;
  width: 12vmax;
  font-size: 0.9em;
  background: white;
  padding: 8%;
  text-align: left;
  position: relative;
}
.checkbox {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 0.2vw;
}
h3 {
  margin-bottom: 1em;
}
.card {
  margin-right: 1em;
  cursor: pointer;
}
.card:hover .text-card > p {
  text-decoration: underline;
}
p {
  font-size: 1.25em;
  margin: 0;
  padding: 1%;
}
img {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .card-image {
    width: 12vw;
  }
  .text-card {
    width: 12vw;
  }
}
.checked {
  background: #5e6a71;
}
.checked > p {
  color: white;
}
@media (max-width: 1024px), (max-height: 768px) {
  .card-image {
    height: 28vh;
    overflow: hidden;
    width: 12vmax;
  }
  .text-card {
    font-size: 9px;
    width: 12vmax;
  }
}
</style>
